if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariantEl = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundaries();
        if (!this.dataset.originalSection) { // I don't think this exists
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;

          fetch(`${this.dataset.url}?variant=${event.data.variant.id}&section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'))
            .then((html) => {

              this.updateQuantityRules(event.data.sectionId, html);
              this.setQuantityBoundaries();
              this.#refreshShareUrl(event.data.variant);
              this.#refreshMedia(event.data.variant);
              this.#refreshPrice(html);
              this.#refreshAddButton(html, event.data.variant);
            });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      fetchQuantityRules() {
        if (!this.currentVariantEl || !this.currentVariantEl.value) {
          return;
        }
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');

        fetch(`${this.dataset.url}?variant=${this.currentVariantEl.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundaries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      setQuantityBoundaries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      setUnavailable() {
        this.#updateAddButton(true, window.variantStrings.unavailable);

        const price = this.querySelector(`#price-${this.dataset.section}`);
        if (price) price.classList.add('visibility-hidden');
      }

      #refreshShareUrl(currentVariant) {
        const shareLink = this.querySelector(`share-button input`);
        if (!shareLink) return;
        shareLink.value = `${window.shopUrl}${this.dataset.url}?variant=${currentVariant.id}`;
      }

      #refreshMedia(currentVariant) {
        const mediaLists = document.querySelectorAll(`[data-section="${this.dataset.section}"].product__media-list`);

        mediaLists.forEach((mediaList) => {
          mediaList.querySelectorAll('.product__media-item--variant').forEach(
            v => v.classList.remove('product__media-item--active'),
          );

          let activeSelector = '.product__media-item--fallback';
          if (currentVariant && currentVariant.featured_media) {
            activeSelector = `[data-media-id="${this.dataset.section}-${currentVariant.featured_media.id}"]`;
          }

          const activeMedia = mediaList.querySelector(activeSelector);

          if (activeMedia) {
            activeMedia.classList.add('product__media-item--active');
            mediaList.prepend(activeMedia);
          }
        });
      }

      #refreshPrice(newDoc) {
        const newPriceSource = newDoc.getElementById(`price-${this.dataset.section}`);
        const priceElement = this.querySelector(`#price-${this.dataset.section}`);

        if (newPriceSource && priceElement) {
          priceElement.innerHTML = newPriceSource.innerHTML;
          priceElement.classList.remove('visibility-hidden');
        }
      }

      #refreshAddButton(newDoc, currentVariant) {
        const newAddButton = newDoc.querySelector(`product-form button[name="add"]`);

        this.#updateAddButton(
          newAddButton ? newAddButton.hasAttribute('disabled') : true,
          currentVariant.available ? window.variantStrings.disabledBuying : window.variantStrings.soldOut,
        );
      }

      #updateAddButton(disable = true, text) {
        const addButton = this.querySelector(`form#product-form-${this.dataset.section} button[name="add"]`);
        if (!addButton) return;
        const addButtonText = addButton.querySelector('span');
        if (!addButtonText) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) {
            addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    },
  );
}
